// Las dos formas del lienzo de un lanzamiento: la lista sola, o la lista
// achicada al costado con el detalle abierto al lado.
//
// Viven acá y no en la pantalla que las estrenó porque las usan DOS: la tabla de
// productos con su ficha, y el calendario de redes con su editor de post
// (ADR-2026-09-15-el-post-se-edita-al-lado-del-calendario). Con una copia en
// cada una, la animación de achicar se vería distinta en cada modo.
//
// Se interpolan con `.transicion-tabla`: para que el navegador pueda animar
// `grid-template-columns`, las dos formas tienen que tener la MISMA cantidad de
// pistas y del mismo tipo.

/** Sólo la lista: ocupa todo y la segunda columna mide cero. */
export const PANTALLA_LISTA = 'minmax(0px,1fr) minmax(0px,0fr)';

/** La lista achicada a un costado y el detalle al lado. */
export const PANTALLA_DETALLE = 'minmax(260px,1fr) minmax(0px,2.4fr)';
